// European countries + Algeria, Morocco, Tunisia
export const COUNTRY_CODES = [
  'AL', 'AD', 'AM', 'AT', 'BY', 'BE', 'BA', 'BG', 'CH', 'CY', 'CZ', 'DE',
  'DK', 'DZ', 'EE', 'ES', 'FI', 'FR', 'GB', 'GE', 'GI', 'GR', 'HU', 'HR',
  'IE', 'IS', 'IT', 'LI', 'LT', 'LU', 'LV', 'MA', 'MC', 'MD', 'MK', 'MT', 'NO', 'NL', 'PL',
  'PT', 'RO', 'RU', 'RS', 'SE', 'SI', 'SK', 'SM', 'TR', 'TN', 'UA', 'VA', 'XK'
]
